import React, { useEffect, useState } from 'react';
// Import images from src/assets
import Photo from '../assets/img/mr.png';
import DownloadCvImg from '../assets/img/download by cv.png'; // Isse bhi import karein
import Cv from '../assets/img/mr.pdf';

const Hero = () => {
  const jobs = ['Developer', 'Designer', 'Freelancer', 'Software Engineer'];
  const [jobIndex, setJobIndex] = useState(0);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setJobIndex((prevIndex) => (prevIndex + 1) % jobs.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [jobs.length]);

  return (
    <section className="profile-intro" id="home">
      <div className="profile-h-content">
        <div className="hero-heading-area" data-aos="fade-up">
          <span className="hero-smaller-title">HI, I'M A FREELANCER</span>
          <h2 className="typing-text stroke-text">
            <span className="jobs">{jobs[jobIndex]}</span>
          </h2>
          <p className="biography-text">
            I'm a software engineer specializing in frontend and backend development. 
            Explore my project portfolio, experience, and online resume.
          </p>
          <div className="main-btn-area">
            <a href="#contact" className="submit-btn">
              <span className="contact-btn-submit">
                Say Hello
                <i className="ph ph-arrow-elbow-down-right"></i>
              </span>
            </a>
          </div>
        </div>

        <div className="hero-image-area" data-aos="fade-left">
          <div className="user-bg"></div>
          {!imageError ? (
            <img 
              src={Photo} 
              className="profile-img" 
              alt="Kuldeep" 
              loading="lazy"
              onError={() => setImageError(true)}
            />
          ) : (
            <div className="hero-image-placeholder">K</div>
          )}

          <div className="hero-download-wrapper">
            <img 
              className="rotate-animation" 
              src={DownloadCvImg} // Yahan variable use karein
              alt="download cv"
            />
            <a href={Cv} download className="cv-download-link" aria-label="Download CV">
              <i className="ph ph-download"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;